import getApi from '../../api'
import { MessageTemplate } from '../../model/MessageTemplate'

export const getDefaultMessageTemplate = () =>
  getApi().get<MessageTemplate | undefined>(`/message_templates/default`)
